import moment from "moment";
import { findKeyBySuffix } from "./findKeyBySuffix";

export const normalizeDate = (value: unknown) => {
  if (!value) return "N/A";

  if (!isNaN(Date.parse(String(value))))
    return moment(value).isValid()
      ? moment(value).format("MMM YYYY")
      : "Invalid date";

  return "Invalid date";
};

export const dateInfo = (item: any): string => {
  const startDate = normalizeDate(
    item[findKeyBySuffix(item, "start_date") || ""]
  );

  const endDateNormalized = item[findKeyBySuffix(item, "end_date") || ""];

  const endDate = endDateNormalized
    ? normalizeDate(endDateNormalized)
    : item?.current_income
      ? "Present"
      : "";
  return `${startDate}${endDate ? ` - ${endDate}` : ""}`;
};
